import type { TFunction } from 'i18next';
import { z } from 'zod';

import { LOCAL_SPECIALTY_MAX_ITEMS } from '../fields/hcp.fields';

export const MultiPrimaryItemSchema = z.object({
	id: z.string(),
	name: z.string().optional(),
	isPrimary: z.boolean().optional(),
	fieldName: z.string().optional(),
	_internalId: z.string().optional()
});

export type MultiPrimaryItemValue = z.input<typeof MultiPrimaryItemSchema>;

type LocalSpecialtyItem = { id?: string | null };

const checkPrimaryRequired =
	(t?: TFunction, required = false) =>
	(items: LocalSpecialtyItem[], ctx: z.RefinementCtx<LocalSpecialtyItem[]>) => {
		const firstFilled = !!items[0]?.id?.trim();
		const anyOtherFilled = items.slice(1).some(item => !!item.id?.trim());

		if (!firstFilled && (required || anyOtherFilled)) {
			ctx.addIssue({
				code: 'custom',
				path: [0, 'id'],
				message: t
					? t('Primary local specialty is required')
					: 'Primary local specialty is required'
			});
		}
	};

export const localSpecialtyArraySchema = (
	t?: TFunction,
	{ required = false }: { required?: boolean } = {}
) =>
	z
		.array(MultiPrimaryItemSchema)
		.max(LOCAL_SPECIALTY_MAX_ITEMS)
		.default([])
		.superRefine((items, ctx) => {
			checkPrimaryRequired(t, required)(items, ctx);
		});

export const localSpecialtyRowLabel = (t: TFunction) => (idx: number) =>
	idx === 0
		? t('Primary Local Specialty')
		: t('Local Specialty {{n}}', { n: idx + 1 });
